import { render, staticRenderFns } from "./MediaComponentForm.vue?vue&type=template&id=73678590&scoped=true&"
import script from "./MediaComponentForm.vue?vue&type=script&lang=ts&"
export * from "./MediaComponentForm.vue?vue&type=script&lang=ts&"
import style0 from "./MediaComponentForm.vue?vue&type=style&index=0&id=73678590&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73678590",
  null
  
)

export default component.exports